import axios from "axios";
import * as APPCONFIG from "../config/app-config.js";
import AuthService from "../session/AuthService.js";
import Http from "./Http.js";
import { decryptData, encryptData } from "../Custom/Custom.js";

var axiosApi = axios.create({
  headers: Http.AUTH_HEADERS(),
  baseURL: APPCONFIG.API_URL,
});

// axiosApi.interceptors.request.use(
//   function (config) {
//     try {
//       if (config.data) {
//         // Encrypt the payload
//         const encrypted = encryptData(config.data);

//         // Backend expects encrypted data in { data: "<cipher>" }
//         config.data = { data: encrypted };
//       }
//     } catch (err) {
//       console.error("Encryption failed in interceptor:", err);
//     }

//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

const isLocalhost = window.location.hostname === "localhost";

axiosApi.interceptors.response.use(
  function (response) {
    try {
      if (!isLocalhost) {
        // Only decrypt if NOT localhost
        if (response.data && typeof response.data.data === "string") {
          const decrypted = decryptData(response.data.data);
          response.data.data = decrypted;
        }
      }
    } catch (err) {
      console.error("Decryption failed in interceptor:", err);
    }

    return response;
  },
  function (error) {
    if (error && error.response) {
      console.error("error:::", error);
      if (error.response.status) {
        switch (error.response.status) {
          case 401:
            AuthService.removeAuth();
            Error("Unauthorized Access");
            window.location.reload();
            break;
          case 503:
            break;
          default:
            break;
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosApi;
